import { makeDocumentMockData } from '../../modules/documentMockDataFactory'
import type { IOpportunityDocument } from '~/types/document/models'

// Seeded with one document so an email written on its Activities tab has one to
// attach (Attach <Record> Documents, modules/email.ts).

export const {
  getDocumentListData: getOpportunityDocumentListData,
  getDocumentDataById: getOpportunityDocumentDataById,
  getDocumentListDataByParentId: getOpportunityDocumentListDataByOpportunityId,
} = makeDocumentMockData<IOpportunityDocument>({
  entityName: 'opportunity',
  storageKeyPrefix: 'opportunity',
  getStartingListData: async () => [
    {
      id: 'XXOD0001',
      hrid: 'OD0001',
      opportunity: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      descr: 'Cogent DIA quote',
      documentType: { id: 10, label: 'Quote' },
      filename: 'cogent-dia-quote.pdf',
      filetype: 'application/pdf',
      filesize: 212480,
      fileChecksum: '4c1f9a7e2b63d0e58a17c94f3b2d6e01',
      fileChecksumAlgorithm: 'md5',
      uploadedByTeamMember: { id: 'XXTM0001', label: 'Meryl Streep' },
      fileUrlPath: '/files/XXOD0001',
      createdAt: '2023-01-12T16:20:00Z',
      version: '1',
      canBeDeleted: true,
    },
  ],
})
